import questionListService from '@/services/questionList.js';

export default {
	debug: false,
	namespaced: true,
	state: {
		questionLists: [],
		questionList: {},
		roundQuestionLists: [],
		searchParams: {
			description: '',
			customerId: '',
			orderBy: 'Name',
			pageSize: 10,
			currentPage: 1
		},
		totalCount: 0,
		totalPages: 0
	},

	mutations: {
		SET_QUESTIONLISTS(state, questionLists) {
			state.questionLists = questionLists;
		},
		SET_QUESTIONLIST(state, questionList) {
			state.questionList = questionList;
		},
		SET_ROUND_QUESTIONLISTS(state, questionLists) {
			state.roundQuestionLists = questionLists;
		},
		SET_PAGESIZE(state, pageSize) {
			state.searchParams.pageSize = pageSize;
		},
		SET_CURRENTPAGE(state, currentPage) {
			state.searchParams.currentPage = currentPage;
		},
		SET_TOTALPAGES(state, totalPages) {
			state.totalPages = totalPages;
		},
		SET_TOTALCOUNT(state, totalCount) {
			state.totalCount = totalCount;
		}
	},

	actions: {
		async getQuestionList({ commit }, questionListId) {
			return await questionListService
				.getQuestionList(questionListId)
				.then(data => {
					commit('SET_QUESTIONLIST', data);
				})
				.catch(err => {
					console.log('Error getting questionList: ', err);
				});
		},
		async getQuestionLists({ state, commit, dispatch, rootGetters }) {
			dispatch('appStore/setLoading', 1, { root: true });

			state.searchParams.customerId = rootGetters['user/getActiveCustomer'].id;
			state.searchParams.companyId = rootGetters['user/getActiveCompany'].id;

			return await questionListService
				.getQuestionLists(state.searchParams)
				.then(data => {
					const paginationValues = data._pagination;

					if (state.searchParams.currentPage <= paginationValues.totalPages || paginationValues.totalPages == 0) {
						commit('SET_QUESTIONLISTS', data);
						commit('SET_CURRENTPAGE', paginationValues.currentPage);
						commit('SET_TOTALCOUNT', paginationValues.totalCount);
						commit('SET_TOTALPAGES', paginationValues.totalPages);
					} else {
						commit('SET_CURRENTPAGE', paginationValues.totalPages);
						dispatch('getQuestionLists');
					}

					dispatch('appStore/setLoading', -1, { root: true });
				})
				.catch(err => {
					console.log('Error getting questionLists: ', err);
					dispatch('appStore/setLoading', -1, { root: true });
				});
		},
		async getAllQuestionLists({ commit, dispatch }, params) {
			dispatch('appStore/setLoading', 1, { root: true });
			var searchParams = {
				...params,
				orderBy: 'Name',
				currentPage: 1,
				pageSize: 0
			};

			return await questionListService
				.getQuestionLists(searchParams)
				.then(data => {
					commit('SET_QUESTIONLISTS', data);
					dispatch('appStore/setLoading', -1, { root: true });
				})
				.catch(err => {
					console.log('Error getting questionLists: ', err);
					dispatch('appStore/setLoading', -1, { root: true });
				});
		},
		async getRoundQuestionLists({ commit, dispatch }, roundPlanningId) {
			dispatch('appStore/setLoading', 1, { root: true });
			var searchParams = {
				roundPlanningId,
				orderBy: 'Name',
				currentPage: 1,
				pageSize: 1000
			};

			return await questionListService
				.getQuestionLists(searchParams)
				.then(data => {
					commit('SET_ROUND_QUESTIONLISTS', data);
					dispatch('appStore/setLoading', -1, { root: true });
				})
				.catch(err => {
					console.log('Error getting fireprotections: ', err);
					dispatch('appStore/setLoading', -1, { root: true });
				});
		},
		async createQuestionList({ dispatch }, questionList) {
			return await questionListService
				.createQuestionList(questionList)
				.then(data => {
					dispatch('getQuestionLists');

					return data;
				})
				.catch(err => {
					console.log('Error creating questionList: ', err);
				});
		},

		async updateQuestionList({ dispatch }, questionList) {
			return await questionListService
				.updateQuestionList(questionList)
				.then(() => {
					dispatch('getQuestionLists');
				})
				.catch(err => {
					console.log('Error updating questionList: ', err);
				});
		},

		async deleteQuestionList({ dispatch }, questionList) {
			return await questionListService
				.deleteQuestionList(questionList.id)
				.then(res => {
					dispatch('getQuestionLists');

					return res;
				})
				.catch(err => {
					console.log('Error deleting questionList: ', err);
				});
		},

		setQuestionList({ commit }, questionList) {
			commit('SET_QUESTIONLIST', questionList);
		},
		setQuestionLists({ commit }, questionList) {
			commit('SET_QUESTIONLISTS', questionList);
		},
		setCurrentPage({ commit }, currentPage) {
			commit('SET_CURRENTPAGE', currentPage);
		},
		setPageSize({ commit }, pageSize) {
			commit('SET_PAGESIZE', pageSize);
		},
		setTotalPages({ commit }, totalPages) {
			commit('SET_TOTALPAGES', totalPages);
		},
		setTotalCount({ commit }, totalCount) {
			commit('SET_TOTALCOUNT', totalCount);
		}
	},

	getters: {
		totalPages: state => {
			return state.totalPages;
		},
		totalCount: state => {
			return state.totalCount;
		},
		currentPage: state => {
			return state.searchParams.currentPage;
		},
		pageSize: state => {
			return state.searchParams.pageSize;
		},
		questionLists: state => {
			return state.questionLists;
		},
		questionList: state => {
			return state.questionList;
		},
		roundQuestionLists: state => {
			return state.roundQuestionLists;
		},
		pagination: state => {
			return {
				currentPage: state.searchParams.currentPage,
				pageSize: state.searchParams.pageSize,
				totalPages: state.totalPages,
				totalCount: state.totalCount
			};
		}
	}
};
